import PackageIcon from "@redotech/redo-icons/package.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.usedParcelLearning;

export const UsedParcelLearningFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: PackageIcon,
  displayName: entry.displayName,
  label: "Package learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
